<template lang="pug">
  .pa-4(v-if="!loading")
    v-row.mb-5(v-if="!noTitle", style="overflow: hidden")
      v-col.d-flex(cols="8")
        h2.display-1.font-weight-light.underline.underline--black {{ label || this.$camelToString(relationName) || this.$camelToString(entity.name) }}
      v-col.d-flex.justify-end(cols="4", v-if="options.deletes")
        v-icon(@click="$emit('close')")  mdi-close
    v-row(v-if="!noTitle")
      v-col.py-0
        h4.font-weight-light {{ loGet(entity, 'description') }}
    //- pre {{ parentEntity }}
    .d-flex.justify-space-between.align-center(:class="{ 'mb-5': listNotDeleted.length }")
      v-tooltip(right)
        template(v-slot:activator="{ on }")
          v-btn.mb-3(fab, small, color="primary", v-on="on", @click="push")
            v-icon mdi-plus
        span Add {{ $pascalToHuman(entity.name) }}
      .actions
        a(@click="showAsTable = true")
          v-icon(:color="showAsTable ? 'geoBlue' : 'grey'") mdi-table
        a(@click="showAsTable = false", v-if="!hasMoreThan3")
          v-icon(:color="showAsTable ? 'grey' : 'geoBlue'") mdi-view-list
    v-data-table(
      dense,
      :headers="$fieldsToHeaders(entity, $fields(entity, 'primitive'))",
      :items="listNotDeleted",
      v-if="showAsTable"
    )
      //- :options.sync="options",
      //- :server-items-length="pagination.total"
      //- template(v-slot:top)
        app-entity-autocomplete(:entity="entity", :emit="true", v-model="where", @input="load()")
      template(v-slot:item.action="{ item }")
        app-entity-modal(
          :entity="entity",
          :value="item",
          :key="item.listIndex",
          @input="update($event)"
        )
          template(v-slot:activator="{ on }")
            a(@click="on.click")
              v-icon(small) mdi-pencil
        a(@click="remove(item)")
          v-icon(small, color="red") mdi-delete
    template(v-for="(i, index) in listNotDeleted", v-if="!showAsTable")
      app-entity-form(
        :key="i._uid + i.listIndex",
        :entity="entity",
        :value="i",
        :options="{ foreigns: true, deletes: true }",
        :only="only",
        :finder="true",
        toggle,
        :errors="formatErrors(index)",
        @input="update($event, index)",
        @close="remove(i, index)",
        :parent="parent",
        :nested="nested + 1",
        fromList
        :parent-entity="parentEntity"
      )
    v-row(v-for="(section, index) in sections")
      v-col(cols="12")
        component(
          v-model="parent[section.name]",
          :is="section.multiple ? 'app-old-entity-list' : 'app-entity-form'",
          :entity="$findEntity(section.type)",
          :load="instance.id && { entity: instance, relation: section.name }",
          :options="{ foreigns: true, deletes: options.deletes }",
          :errors="$formatErrors(errors, section)",
          :ignore="{ relations:[] }",
          :finder="true",
          toggle,
          :parent="instance",
          :nested="nested + 1",
          :parent-entity="entity",
          :relationName="section.name",
          @close="removeTab(section)",
          v-bind="{ disabled }",
        )
</template>

<script>
import axios from 'axios'
import { uid } from '@@/helpers'

export default {
  name: 'entity-list',
  props: {
    entity: null,
    value: null,
    errors: null,
    load: null,
    parent: null,
    only: null,
    parentEntity: null,
    nested: {
      type: Number,
      default: 0
    },
    noTitle: Boolean,
    relationName: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Object,
      default: () => ({
        saves: false,
        deletes: false,
        foreigns: false
      })
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showAsTable: false,
      list: [],
      loading: true,
      instance: {},
    }
  },
  computed: {
    hasMoreThan3 () {
      return this.list.length > 3
    },
    listNotDeleted () {
      return this.list.map((x, listIndex) => ({ ...x, listIndex })).filter(i => i.entityState !== ENV.ENTITY.STATE.DELETED)
    },
    sections() {
      let parentFields = _.get(this.parentEntity, 'fields', []);
      return this.relationName ? parentFields.filter(f => f.section === this.relationName) : [];
    },
  },
  watch: {
    list (list) {
      this.$emit('input', list)
      if (list.length > 3) {
        this.showAsTable = true
      }
    }
  },
  methods: {
    loGet(obj, path, baseValue = null) {
      return _.get(obj, path, baseValue);
    },
    formatErrors (index) {
      return Object.keys(this.errors)
        .filter(k => k.includes(index))
        .map(k => ({ [k.replace(`[${index}]`, '')]: this.errors[k] }))
        .reduce((a, b) => ({ ...a, ...b }), {})
    },
    update (instance) {
      if (_.isEmpty(instance)) return
      const { listIndex, ...rest } = instance
      let temp = [...this.list]
      temp.splice(listIndex, 1, rest)
      this.list = temp
    },
    push () {
      this.list.push({ entityState: ENV.ENTITY.STATE.ADDED, _Entity: this.entity.name, _uid: uid() })
    },

    /**
     * In case of a list, if the child emites the remove event, remove it from the
     * list only if this entity not has an id, if does it means that the entity himself
     * has modified his "EntryState" to deleted.
     */
    remove (item, index) {
      const { listIndex, ...itemInst } = item
      let temp = [...this.list]
      if (!itemInst.id) {
        temp.splice(listIndex, 1)
      } else {
        temp.splice(listIndex, 1, { ...itemInst, entityState: ENV.ENTITY.STATE.DELETED })
      }
      this.list = temp
      // this.$emit('input', list)
    },
    removeTab (section) {
      this.$emit('close', section);
    }
  },

  async mounted () {
    if (this.load) {
      this.list = (
        await this.$fetchEntity(this.load.entity, [this.load.relation], axios)
      )[this.$lcfirst(this.load.relation)] || []
    }
    this.loading = false
  }
}
</script>
